import React from 'react'
const Price = ({ currency = null, value = null, prefix }) => {
   let currencySign
   let price
   const costNum = parseFloat(value)
   if (!isNaN(costNum)) {
      price = costNum.toFixed(2)
   }

   switch (currency) {
      case 'GBP':
         currencySign = <>&pound;</>
         break;
      case 'USD':
         currencySign = '$'
         break;
      default:
         currencySign = null
         break;
   }

   if (currencySign && price) {
      return (
         <>{prefix}{currencySign}{price}</>
      )
   }

   return null
}
export default Price